import React from 'react';
import { hasConversion as hasConversionHelper, getConversionCurrency } from 'helpers/internationalItems';
import { CurrencyConversionRateTooltip } from '../sharedComponents';
const InternationalItemConversionRateTooltip = ({ conversionAmountKey, item, partnership, }) => {
    const hasConversion = hasConversionHelper(item);
    const conversionCurrency = getConversionCurrency(item);
    return (React.createElement(CurrencyConversionRateTooltip, { conversionCurrency: conversionCurrency, country: partnership.countryCodePartner, currencyCodeReceiver: item.currencyCodeReceiver, exchangeRate: item.exchangeRate, hasConversion: hasConversion, isExchangeRateLocked: item.isExchangeRateLocked, plainAmount: item[conversionAmountKey] }));
};
export default InternationalItemConversionRateTooltip;
